import { getIntl } from '../translations/i18n'

export function bytesToHumanReadable(size: number): string {
  const units = ['bytes', 'KB', 'MB', 'GB']
  let unit = 0
  let sizeToTransform = size

  while (sizeToTransform >= 1024 && unit < units.length - 1) {
    sizeToTransform = sizeToTransform / 1024
    unit++
  }

  const localizedNumber = sizeToTransform.toLocaleString(getIntl().locale, {
    maximumFractionDigits: 1,
  })

  return localizedNumber + ' ' + units[unit]
}
